import styled from 'styled-components';

export const PolicyHeader = styled.div`
  padding: 22px 16px 16px 16px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 2px;
  text-align: center;
`;

export const HeaderText = styled.p`
  font-size: 16px;
  color: #000;
  font-family: 'Lato';
  font-weight: 900;
`;

export const PolicyList = styled.div`
  overflow-y: scroll;
  padding: 16px;
  height: 100%;
`;

export const PolicyTitle = styled.p`
  margin-top: 12px;
  font-family: 'Lato';
  font-weight: 700;
`;

export const PolicyDescp = styled.div`
  line-height: 16px;
  color: rgb(74, 74, 74);
  margin-top: 12px;
  font-family: 'Lato';
  font-weight: 400;
  border-bottom-color: rgb(230, 230, 230);
  border-bottom-width: 1px;
  padding-bottom: 12px;
  border-bottom-style: solid;
`;